import { Stack } from "@mui/material";
import { Button } from "@/modules/irohana-components/elements/Button";
import { AppRoutes } from "@/routes/config";
import { useNavigate } from "react-router-dom";
import { FC } from "react";
import { getDynamicRoute } from "@/utils/url";
import { FooterActionBar } from "@/modules/irohana-components/elements/FooterActionBar";

type TOrganizationFooterContainerProps = {
  organizationId?: string;
};

export const OrganizationFooterContainer: FC<TOrganizationFooterContainerProps> = ({ organizationId }) => {
  const navigate = useNavigate();
  const editRoute = getDynamicRoute(AppRoutes.organizationEdit, { id: organizationId });

  return (
    <FooterActionBar>
      <Stack gap={1} direction="row" justifyContent="space-between" alignItems="center">
        <Button size="sm" variant="secondary" onClick={() => navigate(AppRoutes.organizationList)}>
          戻る
        </Button>
        <Button type="button" variant="primary" size="sm" onClick={() => navigate(editRoute)}>
          編集
        </Button>
      </Stack>
    </FooterActionBar>
  );
};
